import { Injectable } from '@angular/core';
import { Router, RouterEvent, NavigationEnd, ActivatedRoute } from "@angular/router";

/** A router wrapper, adding extra functions. */
@Injectable()
export class RouterExtService {

  private previousUrl: string = undefined;
  private currentUrl: string = undefined;

  constructor(public router: Router, private activatedRoute: ActivatedRoute) {
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url.split('/error').length <= 0) {
          console.log('error-page');
        } else {
          this.previousUrl = this.currentUrl.split('/error').length <= 0 ? this.currentUrl : event.url;
          this.currentUrl = event.url;
        }
      };
    });
  }

  public get getPreviousUrl(): string {
    return this.previousUrl;
  }
  public get getCurrentUrl(): string {
    return this.currentUrl;
  }
  public get getQueryParam() {
    return this.activatedRoute.snapshot.queryParams;
  }
  public get getUrlParam() {
    return this.activatedRoute.snapshot.params;
  }
  public get getActivatedRoute() {
    return this.activatedRoute;
  }
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/services/router/router-ext.service.ts